var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-polyline',{key:`${_vm.item.id}_${_vm.item.type}`,attrs:{"path":_vm.item.path.list,"stroke-color":"blue","clicking":true,"stroke-opacity":0.5,"stroke-weight":5,"editing":_vm.editLineId == _vm.item.id},on:{"click":_vm.showMakerInfo,"lineupdate":function($event){return _vm.updatePolylinePath($event,_vm.item)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }